module.exports = __webpack_public_path__ + "autopilot-3-full-4902b43a8eed60f9be2873a502fa58b1.webp";